import { useDispatch } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, WithBillId, WithAccountId } from '@mews-commander/types';
import { Button } from '@optimus-web/core';
import { EllipsizedSpan } from '@mews-commander/ui';
import { getCustomerFullName } from '@mews-commander/legacy-entities/src/ducks/customers';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { getCompanyName } from '@mews-commander/legacy-entities/src/ducks';
import { useCommanderSelector } from '@mews-commander/utils';
import { openModal } from '../../../app';
import { getBillingAccountUrl } from '../../../navigation/billing';

interface ViewBillInAccountButtonProps {
    billId: string;
    accountId: string;
}

export const ViewBillInAccountButton: React.FC<ViewBillInAccountButtonProps> = ({
    billId,
    accountId,
}: WithBillId & WithAccountId) => {
    const dispatch = useDispatch();

    const accountBillingUrl = useCommanderSelector((state: ApplicationState) =>
        getBillingAccountUrl(state, { id: billId, accountId })
    );
    const isCompany = useCommanderSelector((state) => isAccountIdCompany(state, { accountId }));
    const nameSelector = isCompany ? getCompanyName : getCustomerFullName;
    const accountName = useCommanderSelector((state) => nameSelector(state, { id: accountId }));

    const handleSubmit = () => {
        dispatch(openModal(accountBillingUrl));
    };

    return (
        <Button data-test-view-bill-in-account-button onClick={handleSubmit} size="large" wide type="submit">
            <EllipsizedSpan>
                {accountName ? (
                    <LocalizedText textKey={TextKey.PaymentCardViewBillInAccountButton} substitutes={{ accountName }} />
                ) : (
                    <LocalizedText
                        textKey={
                            isCompany
                                ? TextKey.PaymentCardViewBillInAccountButtonCompany
                                : TextKey.PaymentCardViewBillInAccountButtonCustomer
                        }
                    />
                )}
            </EllipsizedSpan>
        </Button>
    );
};
